@if (collection(); as collection) {
<div [title]="label()" class="p-2 flex-auto flex items-center">
  @if (collection.thumb) {
  <aipb-image [src]="collection.thumb" class="mr-2" height="36"></aipb-image>
  }
  <span class="min-w-0 whitespace-nowrap overflow-hidden overflow-ellipsis">{{ label() }}</span>
</div>
}
